export const technologyQuestions = [
  {
    id: 'tech-001',
    category: 'Technology',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'What does URL stand for?',
    options: ['Uniform Resource Locator', 'Universal Routing Link', 'User Reference Label', 'Unified Reader List'],
    answer: 'Uniform Resource Locator',
    insight: 'A URL is the address used to locate a resource on the web.',
    tags: ['internet', 'web', 'url'],
    points: 10,
  },
  {
    id: 'tech-002',
    category: 'Technology',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Which device is used to store files long term?',
    options: ['Hard drive', 'Monitor', 'Keyboard', 'Speaker'],
    answer: 'Hard drive',
    insight: 'Hard drives and SSDs store data even when power is off.',
    tags: ['hardware', 'storage', 'computers'],
    points: 10,
  },
  {
    id: 'tech-003',
    category: 'Technology',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'Cloud storage keeps data on remote servers.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Cloud storage is accessed over a network.',
    tags: ['cloud', 'storage', 'internet'],
    points: 10,
  },
  {
    id: 'tech-004',
    category: 'Technology',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'What does CPU stand for?',
    options: ['Central Processing Unit', 'Computer Power Utility', 'Core Program Unit', 'Central Pixel Unit'],
    answer: 'Central Processing Unit',
    insight: 'The CPU carries out instructions for a computer.',
    tags: ['hardware', 'cpu', 'computers'],
    points: 20,
  },
  {
    id: 'tech-005',
    category: 'Technology',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which technology is commonly used for wireless local networking?',
    options: ['Wi-Fi', 'HDMI', 'USB-C', 'SSD'],
    answer: 'Wi-Fi',
    insight: 'Wi-Fi connects devices wirelessly to local networks.',
    tags: ['networking', 'wifi', 'wireless'],
    points: 20,
  },
  {
    id: 'tech-006',
    category: 'Technology',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'Encryption helps protect data by making it unreadable without a key.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Encryption transforms readable data into protected ciphertext.',
    tags: ['security', 'encryption', 'privacy'],
    points: 20,
  },
  {
    id: 'tech-007',
    category: 'Technology',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'What does AI stand for in technology?',
    options: ['Artificial Intelligence', 'Automated Internet', 'Applied Interface', 'Analog Input'],
    answer: 'Artificial Intelligence',
    insight: 'AI refers to systems that perform tasks associated with intelligence.',
    tags: ['ai', 'machine learning', 'technology'],
    points: 20,
  },
  {
    id: 'tech-008',
    category: 'Technology',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which unit is larger?',
    options: ['Terabyte', 'Gigabyte', 'Megabyte', 'Kilobyte'],
    answer: 'Terabyte',
    insight: 'A terabyte is larger than a gigabyte, megabyte, or kilobyte.',
    tags: ['data', 'storage', 'units'],
    points: 30,
  },
  {
    id: 'tech-009',
    category: 'Technology',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which protocol is commonly used to securely browse websites?',
    options: ['HTTPS', 'FTP', 'SMTP', 'POP3'],
    answer: 'HTTPS',
    insight: 'HTTPS adds encryption to HTTP web traffic.',
    tags: ['security', 'web', 'protocols'],
    points: 30,
  },
  {
    id: 'tech-010',
    category: 'Technology',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'Open-source software can allow users to inspect its source code.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Open-source licenses make source code available under defined terms.',
    tags: ['open source', 'software', 'licenses'],
    points: 30,
  },
];
